import { gql } from '@apollo/client';

export const GET_CUSTOMER_IDS = gql`
  query GetCustomerIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    customers(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
      groupBy: ["id"]
    ) {
      id
    }
  }
`;

export const GET_CUSTOMERS = gql`
  query GetCustomers(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    customers(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      accountNumber
      status
      profile(required: true) {
        id
        name
        phones {
          id
          value
        }
        emails {
          id
          value
        }
        contactAddress {
          id
          street1
          street2
          city
          state
          zip
          zipExt
        }
      }
    }
  }
`;
